import _ from "lodash";

import { saveProfilesRequest } from "../profiles/profiles.actions";
import { activateServices } from "../account";
import {
  Notificator,
  NotificationContext,
} from "../../components/notification";
import { getValidationErrors } from "../../pages/profiles/components/schedule/schedules.selectors";
import { showRemoteReminderDialog } from "../reminder/reminder.actions";

export const finishWizardSetup = (isSingle) => (dispatch, getState) => {
  // TODO: consider putting kind of `isSingle` flag right to the store
  //  so that actions could access it directly without passing it through
  //  components.
  const { schedules } = getState();

  const errors = getValidationErrors(schedules);

  if (!_.isEmpty(errors)) {
    const message = _.get(errors, [0, "message"]);
    return dispatch(
      Notificator.error(message, {
        context: NotificationContext.System,
      })
    );
  }

  dispatch(wizardProcessing());
  dispatch(activateServices(isSingle)).then(() =>
    dispatch(saveProfilesRequest())
      .then(() => dispatch(wizardProcessingSuccess()))
      .then(() => dispatch(showRemoteReminderDialog()))
      .catch(({ customErrors }) => {
        const defaultMsg = "failed_to_create_profiles";
        const message = _.get(customErrors, [0, "message"], defaultMsg);

        dispatch(wizardProcessingFailure());
        dispatch(
          Notificator.error(message, {
            context: NotificationContext.System,
          })
        );
      })
  );
};

export const wizardProcessing = () => ({
  type: WIZARD_PROCESSING,
});

export const WIZARD_PROCESSING = "[WIZARD] WIZARD_PROCESSING";
export const WIZARD_PROCESSING_SUCCESS = "[WIZARD] WIZARD_PROCESSING_SUCCESS";
export const wizardProcessingSuccess = () => ({
  type: WIZARD_PROCESSING_SUCCESS,
});

export const WIZARD_PROCESSING_FAILURE = "[WIZARD] WIZARD_PROCESSING_FAILURE";
export const wizardProcessingFailure = () => ({
  type: WIZARD_PROCESSING_FAILURE,
});
